import React, { Component } from 'react';
import { connect } from 'react-redux';
import Card from './Card/Card';
import TabbedContent from './TabbedContent/TabbedContent';
import { getCitation as getCitationAction } from '../actions/citation';
import BounceLoader from './BounceLoader';
import Notification from './Notification';
import CopyToClipboard from './CopyToClipboard/CopyToClipboard';

const citationTabs = [
  {
    id: 'citation-apa',
    label: 'APA',
    style: 'apa'
  },
  {
    id: 'citation-cell',
    label: 'CELL',
    style: 'cell'
  },
  {
    id: 'citation-chicago',
    label: 'Chicago',
    style: 'chicago-author-date'
  },
  {
    id: 'citation-harvard',
    label: 'Harvard',
    style: 'elsevier-harvard'
  },
  {
    id: 'citation-mla',
    label: 'MLA',
    style: 'modern-language-association'
  },
  {
    id: 'citation-nature',
    label: 'Nature',
    style: 'nature'
  },
  {
    id: 'citation-science',
    label: 'Science',
    style: 'science'
  }
];

const fetchCitation = ({ doc, citations, getCitation }, { style }) => {
  const docCitations = citations[doc.id] || {};
  if (!docCitations[style]) getCitation({ doc, style });
};

const Citation = ({
  doc,
  citation,
  citationStyle,
  track,
}) => {
  if (!citation) {
    return (
      <BounceLoader />
    );
  }

  if (citation.error) {
    return (
      <Notification
        type="error"
        data-name="citation-error"
      >
        Error loading citation string.
      </Notification>
    );
  }

  return (
    <div>
      <p data-name="citation-string" dangerouslySetInnerHTML={{ __html: citation }} />
      <CopyToClipboard
        doc={doc}
        data={citation}
        citationStyle={citationStyle}
        track={track}
        className="text-right"
      />
    </div>
  );
};

const Citations = ({ tabs, onChange }) => (
  <Card title="Cite this document" data-name="cite-this-document">
    <p>Choose a citation style from the tabs below</p>
    <TabbedContent tabs={tabs} onChange={onChange} />
  </Card>
);

class CitationsContainer extends Component {
  state = {
    style: citationTabs[0].style
  }

  componentDidMount() {
    fetchCitation(this.props, this.state);
  }

  componentWillUpdate(props, state) {
    if (process.browser) fetchCitation(props, state);
  }

  render() {
    const { doc, citations, track } = this.props;
    const docCitations = citations[doc.id] || {};
    const trackDetails = style => ({ ...track, action: 'CopyCitation', value: { style } });

    const onChange = index => this.setState({ style: citationTabs[index].style });

    const tabs = citationTabs.map(tab => ({
      ...tab,
      panel: (
        <Citation
          doc={doc}
          citation={docCitations[tab.style]}
          citationStyle={tab.style}
          track={trackDetails(tab.style)}
        />
      )
    }));

    return <Citations tabs={tabs} onChange={onChange} />;
  }
}

const mapStateToProps = ({ citations }) => ({ citations });

const mapDispatchToProps = {
  getCitation: getCitationAction
};

export default connect(mapStateToProps, mapDispatchToProps)(CitationsContainer);



// WEBPACK FOOTER //
// ./src/universal/ui/components/Citations.js